import { get as getByKey } from 'lodash';
import { RESET_ALL as RESET_ON_LOGOUT, danger, notification } from 'redux-store/reducers/common-reducer';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { fetchCampaignProductLists } from './campaign-product-lists';

import { API, get, post, put } from 'utils/api';
import { __t, applyTranslations, t } from 'utils/language';
import { logError } from 'utils/log';
import { createReducer } from 'utils/redux';

import type { Action, CampaignProductList, CampaignProductListFragment, ThunkAction } from 'types';

applyTranslations(require('../components/product-list-modal/product-list-modal.i18n.json'));

const LOADING = 'campaignProductList/LOADING';
const LOADED = 'campaignProductList/LOADED';
const RESET = 'campaignProductList/RESET';

const initialState = {
  list: [],
  isLoading: false
};

export const resetCampaignProductList = (): Action => ({
  type: RESET
});

const setLoadingStatus = (status: boolean): Action => ({
  type: LOADING,
  payload: { status }
});

const campaignProductListLoaded = (data: CampaignProductList): Action => ({
  type: LOADED,

  payload: {
    data
  }
});

export function saveCampaignProductList(
  campaignId: number,
  productListId: number | undefined | null,
  productList: CampaignProductListFragment
): ThunkAction {
  const requestMethod = productListId ? put : post;
  const url = API.END_POINTS.CAMPAIGNS.saveProductList(campaignId, productListId);

  return async (dispatch) => {
    dispatch(showLoading(url));

    try {
      await requestMethod(url, { data: productList });
      dispatch(notification({
        type: productListId ? 'info' : 'success',
        message: __t(`product_list_modal.${productListId ? 'edit' : 'add'}_list_message_success`)
      }));

      dispatch(fetchCampaignProductLists(campaignId));
      dispatch(hideLoading(url));
    } catch (error) {
      logError(error);
      const errorCode = getByKey(error, 'response.data.code');

      if (errorCode !== 'unprocessable.skus') {
        dispatch(danger(t('unknown_error')));
      }

      dispatch(hideLoading(url));
      throw error;
    }
  };
}

export function fetchCampaignProductList(campaignId: number, productListId: number): ThunkAction {
  const url = API.END_POINTS.CAMPAIGNS.getProductList(campaignId, productListId);

  return async (dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      // todo after upload - update list
      const response = await get(url, {}, { suppressGlobalNotification: true });

      dispatch(campaignProductListLoaded(response.data));
      dispatch(setLoadingStatus(false));
    } catch (error) {
      logError(error);

      dispatch(setLoadingStatus(false));
      throw error;
    }
  };
}

export default createReducer<any, any>('campaignProductList', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [LOADED]: (state, { data }) => ({
    ...state,
    list: data,
    isLoading: false
  })
});
